{
  "cashier": "Cashier",
  "depositTab": "Deposit",
  "withdrawTab": "Withdraw",
  "historyTab": "History",
  "secureNote": "Secure & encrypted",
  "selectMethod": "Select payment method",
  "amount": "Amount",
  "amountPlaceholder": "Enter amount",
  "quickAmounts": "Quick amounts",
  "continue": "Continue",
  "depositNow": "Deposit now",
  "withdrawNow": "Request withdrawal",
  "methodDisabled": "This method is not active yet",
  "methodsPending": "Payment requisites are not configured by admin yet",
  "receiptRequired": "Receipt upload is required — a receipt is not proof of payment",
  "adminVerification": "Balance increases only after independent admin verification",
  "noCryptoNetworks": "No crypto networks configured",
  "noAddress": "No deposit address assigned yet",
  "cardToCard": "Card-to-Card",
  "cardToCardDesc": "Bank card transfer",
  "m10": "M10",
  "m10Desc": "M10 transfer",
  "terminal": "Terminal",
  "terminalDesc": "Terminal payment",
  "crypto": "Kriptovalyuta",
  "cryptoDesc": "Crypto deposit",
  "bankCardWithdraw": "Bank card",
  "m10Withdraw": "M10",
  "cryptoWithdraw": "Crypto",
  "minMax": "Min {{min}} — Max {{max}}",
  "trustInstant": "Fast processing when configured",
  "trustSecure": "Secure transactions",
  "trustMethods": "Card-to-Card, M10, Terminal, Crypto",
  "historyEmpty": "No transactions",
  "historyAuth": "Sign in to view history",
  "balanceTitle": "Balance",
  "openCashier": "Cashier",
  "topUp": "Top up",
  "bonusAccount": "Bonus account",
  "reservedFunds": "Reserved",
  "copyId": "Copy my ID",
  "loginRequired": "Sign in to continue",
  "region": "Payment region",
  "instructionsSoon": "Instructions appear here after a requisite is assigned",
  "uploadReceipt": "Upload receipt",
  "uploadDisabled": "Receipts are not accepted before a deposit request exists",
  "depositCreated": "Deposit request created",
  "receiptUploaded": "✅ Receipt uploaded. Your payment request was recorded. Please wait.",
  "withdrawReserved": "Withdrawal reserved",
  "destination": "Recipient details",
  "destinationRequired": "Enter recipient details",
  "noCvv": "CVV and PIN are never required or accepted",
  "status": "Status",
  "copy": "Copy",
  "bankPayment": "Bank payment",
  "currentBalance": "Current balance: {{amount}}",
  "copied": "Copied",
  "selectCoin": "Coin",
  "selectNetwork": "Network",
  "timeRemaining": "Time left",
  "depositExpired": "This deposit request expired. Create a new one.",
  "cancelDeposit": "Cancel request",
  "qrLabel": "Deposit address QR",
  "copyAddress": "Address",
  "cardHolder": "Card holder (optional)",
  "sendExactAmount": "Send the exact amount shown. Wrong network or amount will not be credited.",
  "noPairsConfigured": "No coin/network pair is configured yet",
  "depositCancelled": "Deposit request cancelled",
  "usdRate": "1 USD = {{rate}} AZN",
  "minUsd": "Min ${{usd}}",
  "saveQr": "Save QR",
  "networkWarning": "Send only on the {{network}} network. The wrong network can cause a permanent loss of funds.",
  "filter_all": "All",
  "filter_deposit": "Deposit",
  "filter_withdrawal": "Withdrawal",
  "field_card_number": "Card number",
  "field_card_holder": "Card holder",
  "field_bank_name": "Bank",
  "field_m10_account": "M10 account",
  "field_account_holder": "Account holder",
  "field_terminal_code": "Terminal code",
  "field_address": "Address",
  "field_asset": "Coin",
  "field_network": "Network",
  "field_memo": "Memo",
  "field_phone": "Phone",
  "field_iban": "IBAN",
  "field_name": "Name",
  "methodSelected_card_to_card": "Card-to-card payment selected",
  "methodSelected_m10": "M10 payment selected",
  "methodSelected_terminal": "Terminal payment selected",
  "methodSelected_crypto": "Cryptocurrency selected",
  "cryptoUnavailable": "Cryptocurrency deposit is not ready",
  "cryptoUnavailableHint": "No validated receiving address/network is configured. Do not send funds — a fake wallet is never shown.",
  "quotePreview": "Quote",
  "expectedCredit": "Expected AZN credit",
  "estimatedCrypto": "Estimated crypto amount",
  "adminRateNote": "This rate is set by an admin. It is not a live market price.",
  "enterAmountFirst": "Enter the amount first, then choose coin and network.",
  "status_waiting_for_payment": "Waiting for payment",
  "status_detected": "Transfer detected",
  "status_awaiting_confirmations": "Awaiting confirmations",
  "status_pending_review": "Awaiting review",
  "status_confirmed": "Confirmed",
  "status_expired": "Expired",
  "status_ambiguous": "Needs manual review",
  "status_error": "Error / unsupported",
  "status_cancelled": "Cancelled",
  "status_rejected": "Rejected",
  "status_approved": "Confirmed",
  "expiredLateNote": "A late on-chain transfer can still arrive after expiry. It is not credited automatically and needs a traceable review.",
  "enlargeQr": "Enlarge QR",
  "closeQr": "Close",
  "confirmationTimeNote": "The 10-minute timer is the request waiting window, not blockchain confirmation time.",
  "usdEquivalent": "USD equivalent: ${{usd}}",
  "quoteUnavailable": "Quote unavailable. Check the amount and network.",
  "depositRequests": "Deposit requests",
  "networkMismatch": "Send only on the network shown.",
  "safeRecovery": "Connection lost. Your last saved request will be restored.",
  "historyAll": "All",
  "historyDeposit": "Deposit",
  "historyWithdrawal": "Withdrawal",
  "historyEmptyTitle": "No transaction history",
  "historyEmptyDescription": "Your deposits and withdrawal requests will appear here.",
  "historyBankDeposit": "Bank deposit",
  "statusPending": "Pending",
  "statusReview": "Under review",
  "statusApproved": "Approved",
  "statusPaid": "Paid",
  "statusCompleted": "Completed",
  "statusRejected": "Rejected",
  "statusExpired": "Expired",
  "statusCancelled": "Cancelled",
  "statusFailed": "Failed",
  "withdrawAcceptedClean": "Your withdrawal request was received and sent for review.",
  "selectBankLocal": "Select bank",
  "holderFullNameLocal": "Cardholder full name",
  "recipientCardLocal": "Recipient card number",
  "availableBalanceLocal": "Available balance",
  "backWithdrawalLocal": "Back — withdrawal methods",
  "withdrawDetailsLocal": "Enter withdrawal details",
  "paymentMethodsLocal": "Payment methods",
  "paymentAmountLocal": "Payment amount",
  "transactionTypeLocal": "Transaction type",
  "walletSectionsLocal": "Wallet sections",
  "cryptoTransferTitle": "Crypto deposit",
  "cryptoTransferAmount": "Amount to send",
  "cryptoOrderAmount": "Order amount",
  "cryptoTransferAddress": "Wallet address",
  "cryptoTransferNetwork": "Network",
  "cryptoShowQr": "Show QR code",
  "cryptoQrWaiting": "QR code unavailable",
  "cryptoNoAddress": "No address available. Do not send funds.",
  "cryptoWarnNetwork": "Send only {{asset}} over the {{network}} network. Funds sent via the wrong network may be lost.",
  "cryptoWarnAmount": "Check the amount and network fee carefully. An insufficient transfer may not be credited.",
  "cryptoMoreInfo": "Additional payment details",
  "cryptoMemo": "Memo / Tag",
  "prevStep": "Previous step",
  "depositAmount": "Deposit amount",
  "paymentInstruction": "Payment instructions",
  "paymentConfirm": "Payment confirmation",
  "depositStages": "Deposit steps",
  "stageAmount": "Amount",
  "stagePayment": "Payment",
  "stageReceipt": "Receipt",
  "receiptSend": "Send receipt",
  "rejected": "Rejected",
  "network": "Network",
  "paymentNote": "Payment note",
  "extraPaymentInfo": "Additional payment details",
  "invalidAmount": "Enter a valid amount.",
  "tapToSelect": "Tap to select",
  "walletLabel": "Wallet",
  "previewBanner": "TEST MODE: All payment cards are selectable. Do not send real money; deposits and withdrawals are not executed.",
  "otherBank": "Other bank",
  "cryptoAsset": "Cryptocurrency",
  "receiveAddress": "Deposit address",
  "notAssigned": "Not assigned",
  "paymentMethod": "Payment method",
  "bank": "Bank",
  "recipient": "Recipient",
  "cardNumber": "Card number",
  "qrWhenReady": "QR appears only when a real address is available",
  "qrInactive": "QR inactive",
  "qrInactiveHint": "Shown here once a deposit address is assigned.",
  "networkAttention": "Attention: {{network}} network",
  "networkAttentionBody": "Send only to an address on the selected network. Wrong network or amount may cause loss of funds.",
  "minDepositFees": "Minimum deposit and fees",
  "minDepositFeesBody": "Check the minimum amount and network fee before sending. Do not transfer without a deposit address.",
  "waitingTransfer": "Waiting for your transfer",
  "waitingTransferBody": "Pay only to the confirmed recipient details for the exact amount shown.",
  "wrongTransfer": "About incorrect transfers",
  "wrongTransferBody": "Payments to the wrong bank, card or amount may not be credited.",
  "previewNoAddress": "TEST MODE · NO PAYMENT ADDRESS · DO NOT SEND MONEY",
  "addReceiptTitle": "Attach payment receipt",
  "addReceiptBody": "Take a photo, pick from gallery or attach a file. In test mode the file is not uploaded to the server.",
  "cameraCapture": "Take photo",
  "sampleTimer": "Sample timer — no real request created",
  "transferDetails": "Transfer details",
  "paymentDetailsStep": "Payment details",
  "paymentConfirmStep": "Payment confirmation",
  "iPaidReceipt": "I paid · Receipt screen",
  "fromGallery": "Choose from gallery",
  "chooseFile": "Choose file",
  "cameraFileSelected": "Camera file selected: {{name}}. Not uploaded in test mode.",
  "imageSelected": "Image selected: {{name}}. Not uploaded in test mode.",
  "fileSelected": "File selected: {{name}}. Not uploaded in test mode.",
  "previewTest": "Test",
  "fileNotUploaded": "File is not uploaded to the server",
  "bankSelect": "Bank selection",
  "depositBonusSample": "Deposit bonus · sample",
  "checkFinalAmount": "Check the final amount on the created order.",
  "cryptoAwaitingAdmin": "No receipt upload is required for crypto. An admin will verify the blockchain transfer and only then credit your balance.",
  "err_asset_quote_missing": "No rate is available for this crypto asset. Try again later or choose another asset.",
  "err_asset_quote_stale": "The crypto rate is stale. Wait for a refresh and try again.",
  "err_gram_min_not_met": "Minimum GRAM deposit is 2 GRAM.",
  "err_amount_out_of_limits": "Amount is outside allowed limits.",
  "err_no_active_requisite": "No receiving address is configured for this asset/network yet.",
  "err_unsupported_crypto_pair": "This asset and network pair is not supported.",
  "err_receipt_not_required_for_crypto": "Receipt upload is not required for crypto deposits.",
  "err_asset_feed_unavailable": "Crypto rate feed is unavailable.",
  "orderNumber": "Order number:",
  "amountDue": "Amount due:",
  "requestProcessing": "Request is processing",
  "paymentCreated": "Payment request created successfully!",
  "completeTransferHint": "Please complete the transfer using the payment details below.",
  "exactAmountWarn": "Attention! Send only the shown amount using the correct payment details.",
  "uploadReceiptAfter": "After completing the transfer, upload the payment receipt.",
  "paymentInfo": "Payment details",
  "cardHolderName": "Cardholder name",
  "receiverName": "Recipient name",
  "accountNumber": "Account number",
  "previewDepositSelected": "TEST MODE: {{method}} — {{amount}} AZN selected. No real deposit created; do not send money.",
  "previewWithdrawChecked": "TEST MODE: {{amount}} AZN withdrawal for {{method}} checked. No real request created.",
  "checkingFileSelection": "Checking your file selection",
  "bonusSampleLine": "5%: {{bonus}} · total: {{total}}",
  "phoneNumber": "Phone number",
  "addressLabel": "address",
  "uploadReceiptReminder": "After completing payment, remember to upload your receipt.",
  "previewWithdrawBanner": "TEST MODE: Real withdrawals are not sent and balance does not change.",
  "cardExpiry": "Card expiry (MM/YY)",
  "checkRequest": "Check request",
  "bonusNotOnReal": "Not credited to the real balance.",
  "tonConnectTitle": "TON Connect · GRAM",
  "tonConnectWallet": "Connect TON wallet",
  "tonPayConfirm": "Confirm payment in wallet",
  "tonDisconnectWallet": "Disconnect wallet",
  "tonWalletStatus": "Wallet status",
  "tonWalletNotConnected": "Not connected",
  "tonWalletConnected": "Connected · {{address}}",
  "tonWalletConnectedHint": "Your TON wallet was linked successfully.",
  "tonWalletDisconnected": "Wallet disconnected.",
  "tonWalletConnectFailed": "Wallet connection failed.",
  "tonConnectWalletFirst": "Connect a TON wallet first.",
  "tonConfirmInWallet": "Confirm the payment in your wallet.",
  "tonPendingAdminReview": "Your deposit request was created. Payment is awaiting admin verification.",
  "tonDepositCreated": "TON deposit request created. Complete payment with your wallet.",
  "tonPaymentCancelled": "Payment was cancelled or not completed.",
  "tonPaymentMissing": "Payment details missing. Please try again.",
  "tonPaymentProofMissing": "Wallet did not return payment proof. If payment did not complete, try again.",
  "tonWarnNativeOnly": "Send only the official GRAM jetton (master EQC47093…). Native TON or lookalike GRAM* tokens are not accepted.",
  "tonWarnAdminReview": "Wallet confirmation is not a balance credit. Balance increases only after admin verifies the on-chain transfer.",
  "realBalance": "Real balance",
  "gameCurrencies": "Game currencies",
  "walletCta": "Wallet",
  "closeGameFirst": "An active game still has open bets. Close the game, then change currency.",
  "regionLabel": "Payment region",
  "regionCryptoOnly": "Only crypto payments are available in this region",
  "gameCurrency": "Game currency",
  "tonWarnGramJettonOnly": "Send only the official GRAM jetton (master EQC47093…). Native TON or lookalike GRAM* tokens are not accepted.",
  "tonPayConfirmGram": "Confirm GRAM jetton payment in wallet",
  "tonJettonMaster": "GRAM jetton contract",
  "tonGramWalletMissing": "No GRAM jetton wallet found for this account. Add GRAM first or use address/QR transfer.",
  "tonGramConnectUnavailable": "TON Connect GRAM transfer is temporarily unavailable. Address and QR deposit still work."
}
